import React from 'react';

const FileIcon = () => (
  <svg
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.60864 1H17.6086V1V14.3043C17.6086 16.887 15.0675 19 11.9616 19H1.60864V19V1V1Z"
      stroke="#555B67"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M6.05298 7.29957L9.14379 9.99904L12.7101 4.6001"
      stroke="#555B67"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path d="M5.51213 13.5999H13.5121" stroke="#555B67" strokeWidth="2" />
  </svg>
);

export default FileIcon;
